import { render, staticRenderFns } from "./AppCardHeading.vue?vue&type=template&id=52c540fc"
import script from "./AppCardHeading.vue?vue&type=script&lang=js"
export * from "./AppCardHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../routestatus/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports